import { useEffect, useState } from "react";

import { useSelectedLocation } from "components/DealersAndLocationsDropdown/hooks";
import { setSpecialIndicatorsToFilter, useSpecialIndicatorsToFilter } from "modules/Appointments/hooks";
import { APPOINTMENTS_STORAGE_KEYS } from "modules/Appointments/storageKeys";
import { indicatorsFiltrationLogic, initializeIdentifiers } from "modules/Appointments/util";

import type { DealerLocation } from "models";
import type { IndicatorFilters } from "modules/Appointments/components";

export type SpecialIndicatorData = {
  is_star?: string;
  is_money?: string;
  is_recurring?: string;
  pin_count?: string;
};

const getSpecialIndicators = (specialIndicatorsData?: SpecialIndicatorData, selectedLocation?: DealerLocation | null): IndicatorFilters[] => [
  { icon: "is_money", active: !!specialIndicatorsData?.is_money, filter: "is_money" },
  ...(selectedLocation?.pin_visible ? [{ icon: "pin", active: !!specialIndicatorsData?.pin_count, filter: "pin_count" }] : []),
  { icon: "triangle exclamation", active: !!specialIndicatorsData?.is_recurring, filter: "is_recurring" }
];

export const useGetSpecialIndicators = () => {
  const { selectedLocation } = useSelectedLocation();
  const specialIndicatorsData = useSpecialIndicatorsToFilter();
  const specialIndicators = getSpecialIndicators(specialIndicatorsData, selectedLocation);
  const currentFilterData = useSpecialIndicatorsToFilter();
  const [indicatorFilters, setIndicatorFilters] = useState<IndicatorFilters[]>(
    initializeIdentifiers(specialIndicators, APPOINTMENTS_STORAGE_KEYS.SpecialIndicatorsPreference)
  );

  useEffect(() => {
    const updateIndicatorsData = () => {
      const indicatorFiltersObj = [...indicatorFilters].filter(item => item.active && item.filter).reduce((acc, item) => ({ ...acc, [item.filter]: item.filter }), {});

      if (JSON.stringify(currentFilterData) !== JSON.stringify(indicatorFiltersObj)) {
        setSpecialIndicatorsToFilter(indicatorFiltersObj);
      }
    };

    updateIndicatorsData();
  }, [indicatorFilters]);

  const handleIndicatorFilters = (index: number) => {
    setIndicatorFilters(current => indicatorsFiltrationLogic(current, index, APPOINTMENTS_STORAGE_KEYS.SpecialIndicatorsPreference));
  };

  return { indicatorFilters, handleIndicatorFilters };
};
